/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../api/types.generated";
export type GetAllGooseGameHackerQuestsQueryVariables = Types.Exact<{
  eventId: Types.Scalars["Float"];
}>;

export type GetAllGooseGameHackerQuestsQuery = {
  gooseGameQuests: Array<
    Pick<
      Types.GooseGameQuest,
      | "id"
      | "title"
      | "type"
      | "points_rewarded"
      | "completion_limit"
      | "question_string"
      | "description"
      | "quest_event_activity_category"
      | "hidden"
      | "flash"
    >
  >;
};

export const GetAllGooseGameHackerQuestsDocument = gql`
  query GetAllGooseGameHackerQuests($eventId: Float!) {
    gooseGameQuests(event_id: $eventId) {
      id
      title
      type
      points_rewarded
      completion_limit
      question_string
      description
      quest_event_activity_category
      hidden
      flash
    }
  }
`;

/**
 * __useGetAllGooseGameHackerQuestsQuery__
 *
 * To run a query within a React component, call `useGetAllGooseGameHackerQuestsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllGooseGameHackerQuestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllGooseGameHackerQuestsQuery({
 *   variables: {
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useGetAllGooseGameHackerQuestsQuery(
  baseOptions?: ApolloReactHooks.QueryHookOptions<
    GetAllGooseGameHackerQuestsQuery,
    GetAllGooseGameHackerQuestsQueryVariables
  >
) {
  return ApolloReactHooks.useQuery<
    GetAllGooseGameHackerQuestsQuery,
    GetAllGooseGameHackerQuestsQueryVariables
  >(GetAllGooseGameHackerQuestsDocument, baseOptions);
}
export function useGetAllGooseGameHackerQuestsLazyQuery(
  baseOptions?: ApolloReactHooks.LazyQueryHookOptions<
    GetAllGooseGameHackerQuestsQuery,
    GetAllGooseGameHackerQuestsQueryVariables
  >
) {
  return ApolloReactHooks.useLazyQuery<
    GetAllGooseGameHackerQuestsQuery,
    GetAllGooseGameHackerQuestsQueryVariables
  >(GetAllGooseGameHackerQuestsDocument, baseOptions);
}
export type GetAllGooseGameHackerQuestsQueryHookResult = ReturnType<
  typeof useGetAllGooseGameHackerQuestsQuery
>;
export type GetAllGooseGameHackerQuestsLazyQueryHookResult = ReturnType<
  typeof useGetAllGooseGameHackerQuestsLazyQuery
>;
export type GetAllGooseGameHackerQuestsQueryResult =
  ApolloReactCommon.QueryResult<
    GetAllGooseGameHackerQuestsQuery,
    GetAllGooseGameHackerQuestsQueryVariables
  >;
